import { useMutation } from '@tanstack/react-query';

import type { CartLineCustomizationFile } from '@nucleus-commerce/api-client/admin';

import { uploadsApi } from '../api/uploads-api';

function saveBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** Fetches a shopper upload as a blob and saves it under its original filename. */
export function useDownloadUpload(storeId: string) {
  return useMutation({
    mutationFn: async (file: CartLineCustomizationFile) => {
      const blob = await uploadsApi.download(storeId, file.id);
      saveBlob(file.filename, blob);
    },
  });
}
